import styled, { css } from 'styled-components';

import { COLORS, MOBILE, SPACE } from '../../../../theme/tokens';
import { Callout } from '../../../../components';
// A read of the shared Callout's action slot, so this caller can re-pin it. The component itself is
// untouched (it gains no dismiss prop); the house precedent for reading a shared styles module.
import { Action as CalloutAction, IconWrap as CalloutIconWrap, TONES } from '../../../../components/Callout/Callout.styles';

/**
 * The scenario's ONE banner grammar: the shared Callout with a dismiss X in its action slot,
 * re-pinned top-right at every width (Callout stacks the action under the copy on mobile, which is
 * right for a button and wrong for a close affordance). Used by the create form's price banner and
 * the mailbox page's password notices.
 */
export const Notice = styled(Callout)<{ $noIcon?: boolean }>`
  /* The info tone's stroke is the panel-border hairline, the same line as every panel edge, so an
     info banner reads as a slab of background rather than a notice. Here it takes the tone's own
     glyph colour instead (Callout's TONES, so the two cannot drift). On this wrapper only: the
     shared Callout's info tone stays as it is for every other caller. warning/success unchanged. */
  ${(p) =>
    p.tone === 'info'
      ? css`
          border-color: ${TONES.info.fg};
        `
      : ''}

  /* hideIcon: Callout always renders its tone glyph; a banner directly under a row that already
     leads with an icon drops it, through the styles rather than a prop on the shared component. */
  ${(p) =>
    p.$noIcon
      ? css`
          ${CalloutIconWrap} {
            display: none;
          }
        `
      : ''}

  ${CalloutAction} {
    align-self: flex-start;

    ${MOBILE} {
      flex: 0 0 auto;
      margin-left: auto;
      padding-left: 0;
    }
  }
`;

/** The dismiss X: a bare 24px icon button; the 2px pull-up is optical alignment against the
 *  banner's first line, not a spacing value. */
export const DismissButton = styled.button`
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  margin: -${SPACE[2]} 0 0;
  padding: 0;
  border: none;
  border-radius: 99px;
  background: transparent;
  color: ${COLORS.icon};
  cursor: pointer;

  &:hover {
    background: ${COLORS.surfaceMuted};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.accent};
    outline-offset: 2px;
  }
`;
